import api from './api';

export interface Vendedor {
    nroVendedor: number;
    nombreVendedor: string;
    nroCuentaLiquidacion?: number;
    comisionPorc?: number;
    comisionBase?: string;
    lockLiquidacion?: number;
    direccion?: string;
    codigoCiudad?: number;
    dni?: number;
    legajo?: string;
    telefono?: string;
    remuneracion?: number;
    notas?: string;
    lunes?: number;
    martes?: number;
    miercoles?: number;
    jueves?: number;
    viernes?: number;
    sabado?: number;
    domingo?: number;
    horaElun?: string | null;
    horaSlun?: string | null;
    horaEmar?: string | null;
    horaSmar?: string | null;
    horaEmie?: string | null;
    horaSmie?: string | null;
    horaEjue?: string | null;
    horaSjue?: string | null;
    horaEvie?: string | null;
    horaSvie?: string | null;
    horaEsab?: string | null;
    horaSsab?: string | null;
    horaEdom?: string | null;
    horaSdom?: string | null;
    turno?: number;
    comisionServicio?: number;
    comisionBaseServicio?: string;
    nroProveedor?: number;
    tipoVendedor?: string;
    referenciaErp?: string | null;
    sincronizar?: number;
    grupoMcpMobile?: number;
    usuario?: string;
}

const vendedorService = {
    getVendedores: async (): Promise<Vendedor[]> => {
        const response = await api.get<Vendedor[] | { items: Vendedor[] }>('/api/Vendedores');
        const data = response.data;
        
        // Si la respuesta es un array directo
        if (Array.isArray(data)) {
            return data;
        }
        
        // Si tiene estructura con items
        if (data && typeof data === 'object' && 'items' in data) {
            return Array.isArray(data.items) ? data.items : [];
        }
        
        return [];
    },

    getVendedor: async (nroVendedor: number): Promise<Vendedor | null> => {
        try {
            const vendedores = await vendedorService.getVendedores();
            return vendedores.find(v => v.nroVendedor === nroVendedor) || null;
        } catch (error) {
            console.error('Error al obtener vendedor:', error);
            return null;
        }
    }
};

export default vendedorService;

